import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { NonLifeInsuranceFormFields } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/NonLifeInsuranceFormFields";
import { useEditNonLifeInsuranceForm } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/useEditNonLifeInsuranceForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditNonLifeInsuranceFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditNonLifeInsuranceForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditNonLifeInsuranceFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useEditNonLifeInsuranceForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<NonLifeInsuranceFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
